import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, { IMAGE_DISABLED } from './DefaultCatalogConfig';

export default class ThemesCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);

    this.allowHoverActions = props.isEditorForCurrentMarket;
    this.item.copy = this.editable;
    this.item.remove = this.editable;
    this.item.cut = this.editable;
    this.allowRanking = props.isGlobalMarket || props.isEditorForCurrentMarket;
    this.moveDisabled = false;
    this.newCategory = this.editable;
    this.category.productImage = IMAGE_DISABLED;
    this.category.categoryType =
      props.isGlobalMarket && props.isEditorForCurrentMarket;

    this.catalog.translation = props.isEditorForCurrentMarket;
  }
}
